import { useState, useEffect } from 'react';

const WELCOME_POPUP_KEY = 'blackbook_welcome_popup_shown';

export function useWelcomePopup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    // Check if user has already seen the popup
    const hasSeenPopup = localStorage.getItem(WELCOME_POPUP_KEY);
    
    if (!hasSeenPopup) {
      // Show popup after a short delay for better UX
      const timer = setTimeout(() => {
        setShowPopup(true);
      }, 2000); // 2 second delay

      return () => clearTimeout(timer);
    }
  }, []);

  const closePopup = () => {
    setShowPopup(false);
    // Mark that user has seen the popup
    localStorage.setItem(WELCOME_POPUP_KEY, 'true');
  };

  const resetPopup = () => {
    localStorage.removeItem(WELCOME_POPUP_KEY);
    setShowPopup(true);
  };

  return {
    showPopup,
    closePopup,
    resetPopup
  };
}